export default function renderPaymentConfirmationModalRefundCopy(lang, amount) {
  if (lang === 'fr') {
    return `La somme de ${amount} $ sera automatiquement remboursée.`
  }

  return `The amount of $${amount} will be automatically refunded`
}
